import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["React", "ReactDOM", "ReactDOMClient"];
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { babelTransform } from "./transform.js";
import ReactDOM from 'react-dom';
export var getReactDOMClient = () => {
  var _ReactDOM;
  try {
    // 使用 require 解决 react v17 ts 报错问题
    _ReactDOM = require('react-dom/client');
  } catch (err) {
    // console.warn(`如果使用的是react-dom小于v18的版本，可以忽略此警告：${err}`)
  }
  return _ReactDOM;
};
export function useCodePreview(props) {
  var [demoDom, setDemoDom] = useState();
  var playerId = useRef("" + parseInt(String(Math.random() * 1e9), 10).toString(36));
  var [fullScreen, setFullScreen] = useState(false);
  var [errorMessage, setErrorMessage] = useState('');
  var [showEdit, setShowEdit] = useState(false);
  var [width, setWidth] = useState(1);
  var [copied, setCopied] = useState(false);
  var [code, setCode] = useState(props.code || '');
  var ReactDOMClient = React.useMemo(() => {
    return window.ReactDOM ? window.ReactDOM : getReactDOMClient();
  }, []);

  /** 通过缓存的方式 解决 react v18 中 的报错   ***/
  // @ts-ignore
  var cachesRef = React.useRef(new Map([]));
  var ReactDOMRender = _ReactDOM => {
    return {
      createRoot: id => {
        return {
          render: _render => {
            var caches = cachesRef.current;
            var root = caches.get(id);
            // 存在则不需要重新创建直接进行render操作
            if (root) {
              root.render(_render);
            } else {
              // @ts-ignore
              root = _ReactDOM.createRoot(document.getElementById(id));
              root.render(_render);
              // 缓存，解决控制台报  ReactDOMClient.createRoot 问题
              caches.set(id, root);
            }
            cachesRef.current = caches;
          }
        };
      }
    };
  };
  /**  ------------------------   ***/

  var executeCode = str => {
    var _ref = props.dependencies || {},
      {
        React: _React,
        ReactDOM: _ReactDOM,
        ReactDOMClient: _ReactDOMClient
      } = _ref,
      otherDeps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var V18ReactDOM = _ReactDOMClient || ReactDOMClient || _ReactDOM || ReactDOM;
    // 判断是否是 react v18版本
    var isV18 = Reflect.has(V18ReactDOM, 'createRoot');
    var NewReactDOM = isV18 ? ReactDOMRender(V18ReactDOM) : V18ReactDOM;
    try {
      var deps = _extends({
        React: _React || React
      }, otherDeps, {
        ReactDOM: NewReactDOM
      });
      // const args = ['context', 'React', 'ReactDOM', 'Component'];
      var args = [];
      // const argv = [this, React, ReactDOM, Component];
      var argv = [];
      for (var key in deps) {
        args.push(key);
        argv.push(deps[key]);
      }
      if (isV18) {
        // react < v18 中写法替换
        str = str.replace('ReactDOM.render', "ReactDOM.createRoot(\"" + playerId.current + "\").render");
        // react v18 中写法替换
        str = str.replace("ReactDOM.createRoot(_mount_)", "ReactDOM.createRoot(\"" + playerId.current + "\")");
        str = str.replace('_mount_', "");
      } else {
        str = str.replace('_mount_', "document.getElementById('" + playerId.current + "')");
      }
      var input = "" + str;
      var {
        code: _code
      } = babelTransform(input);
      args.push(_code || '');
      // console.log('code:', argv)
      // eslint-disable-next-line no-new-func
      new Function(...args).apply(null, argv);
      setErrorMessage('');
    } catch (err) {
      var message = '';
      if (err && err.message) {
        message = err.message;
      } else {
        message = JSON.stringify(err);
      }
      setErrorMessage(message);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => executeCode(code), [code, props.noPreview, demoDom]);
  return {
    playerId,
    demoDom,
    setDemoDom,
    fullScreen,
    setFullScreen,
    errorMessage,
    setErrorMessage,
    width,
    setWidth,
    showEdit,
    setShowEdit,
    copied,
    setCopied,
    code,
    setCode,
    executeCode
  };
}